<button
  type="button"
  class="btn overflow-hidden justify-start"
  [disabled]="disabled"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="onMenuClosed()"
  [matTooltip]="items[selectedId!]?.name || ''"
  [matMenuTriggerFor]="singleSelectMenu"
>
  <span class="uppercase span-wrapper" [ngSwitch]="!!selectedId" [style.background]="items[selectedId!]?.color">
    <span *ngSwitchCase="false">Select status</span>
    <span *ngSwitchCase="true" class="d-inline-block ellipsis">{{ items[selectedId!]?.name }}</span>
    <craft-icon class="svg-icon ml-4 text-size-11" name="arrows--arrow-head-down-sm"></craft-icon>
  </span>
</button>

<mat-menu #singleSelectMenu="matMenu">
  <ng-template matMenuContent="">
    <div *ngIf="hasSearch" class="menu-search mat-mdc-menu-item d-flex align-items-center shrink-0">
      <craft-icon class="svg-icon text-size-13 mr-10" name="search--search"></craft-icon>
      <input type="text" #searchInput (click)="$event.stopPropagation()" [placeholder]="searchPlaceholder" [formControl]="searchControl" />
    </div>

    <button
      mat-menu-item=""
      *ngFor="let item of filteredItems | async | slice: 0 : 100; trackBy: identify"
      [ngClass]="{ selected: selectedId === item.id }"
      (click)="selectItem(item)"
      craftDisableFocus=""
      type="button"
    >
      <span class="oval" [style.background]="item.color"></span>
      <span>{{ item.name }}</span>
    </button>
  </ng-template>
</mat-menu>
